import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { ResultPageModel } from '../../../Core/SortingAndPaging/Models/ResultPageModel';
import { ValuationPoint } from '../../../Models/Models/PortfolioAnalysis/Investment/ValuationPoint';
import { IJsonDate } from '../../../System/IJsonDate';
import { Frequency } from '../../../Constants/Enums/Domain/Frequency';

declare var IS_RUNNING_IN_APP_POOL;

export class InstrumentValuationDistributionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(investmentCode: string, from: IJsonDate, to: IJsonDate, frequency: Frequency, currentPage: number, resultsPerPage: number): Promise<ResultPageModel<ValuationPoint>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioAnalysis/Investment/InstrumentValuationDistribution/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { investmentCode: investmentCode, from: from, to: to, frequency: frequency, currentPage: currentPage, resultsPerPage: resultsPerPage }

    return AjaxWrapper.get<ResultPageModel<ValuationPoint>, any>(url, data);
  }
}

